import store from '@/store'
const AuthService = {
  install (Vue) {
    Vue.prototype.$auth = {
      store: (token, expiration) => {
        const data = {
          _token: token,
          _expire_at: expiration
        }
        localStorage.setItem('_token', JSON.stringify(data))
      },
      remove: () => {
        localStorage.removeItem('_token')
      },
      token: () => {
        if ('_token' in localStorage) {
          if (new Date().getTime() > JSON.parse(localStorage.getItem('_token'))._expire_at) {
            localStorage.removeItem('_token')
            store.dispatch('setUser', null).catch()
            store.dispatch('setRole', null).catch()
            return '_token' in localStorage
          }
          return '_token' in localStorage
        }
        return false
      },
      bearer: () => {
        return JSON.parse(localStorage.getItem('_token'))
      }
    }
  }
}

export default (AuthService)
